<template>
  <div class="cmzOrder">
    <headBox title="方案定制跟进" class="headerBox">
      <ahb-header :num="nums"></ahb-header>
    </headBox>
     <div class="from">
      <topSearchForm @search="query(1)" :hiddenExport="true" :showSwtich="true">
        <el-form :inline="true" class="rform" :model="search" ref="loginform">
          <el-form-item label="购买方案时间" prop="data" class="items small">
            <a-range-picker v-model="searchData" format="yyyy-MM-DD" valueFormat="yyyy-MM-DD" separator="至">
              <i class="icon-riqixuanze" slot="suffixIcon"></i>
            </a-range-picker>
          </el-form-item>
          <el-form-item label="微信号" prop="sasa" class="item small1">
            <el-input
              type="text"
              placeholder="请输入客户微信号"
              v-model="wechat"
              clearable
              class="code"
            ></el-input>
          </el-form-item>
          <el-form-item label="方案类型" prop="sasa" class="item small1">
            <el-select v-model="planValue" clearable placeholder="请选择">
              <el-option
                v-for="item in planArr"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户信息" prop="sasa" class="item">
            <el-input
              type="text"
              placeholder="请输入客户姓名或者手机号"
              v-model="nameOrPhone"
              clearable
              class="code"
            ></el-input>
          </el-form-item>
          <el-form-item label="支付状态" prop="sasa" class="item">
            <el-select v-model="zfValue" clearable placeholder="请选择">
              <el-option
                v-for="item in zfArr"
                :key="item.statu"
                :label="item.desc"
                :value="item.statu"
              >
              </el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="预约来源" prop="source" class="item">
            <el-select v-model="source" clearable placeholder="请选择">
              <el-option v-for="(item,key) in all.SUBSCRIBE_SOURCE" :key="key" :label="item" :value="key" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="跟进状态" prop="sasa" class="item">
            <el-select v-model="gjValue" clearable placeholder="请选择">
              <el-option
                v-for="item in gjArr"
                :key="item.statu"
                :label="item.desc"
                :value="item.statu"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否有成交保单" prop="sasa" class="item">
            <el-select class="only-select1" v-model="isDeal" clearable placeholder="请选择">
              <el-option label="是" value="1">是</el-option>
              <el-option label="否" value="0">否</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单类型" prop="sasa" class="item">
            <el-select v-model="khlxValue" clearable placeholder="请选择">
              <el-option
                v-for="item in khlxArr"
                :key="item.statu"
                :label="item.desc"
                :value="item.statu"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </topSearchForm>
    </div>
    <div class="info-box">
      <div class="total-num">
        <span>共</span>
        <span class="num-color">{{orderPage}}</span>
        <span>单</span>
      </div>
      <div>
        <span>成交保单数: </span>
        <span class="num-color">{{statistics.totalNum}}单</span>
      </div>
      <div>
        <span>成交保费: </span>
        <span class="num-color">{{statistics.totalFee}}元</span>
      </div>
      <div>
        <span>成交服务费: </span>
        <span class="num-color">{{statistics.totalIncomes}}元</span>
      </div>
      <el-button class="derive-btn" @click="exportPolicyExcel">导出</el-button>
    </div>

    <div class="body-card" v-loading="loading">
      <div class="info-body clearfix">
        <div class="table-head table-row">
          <el-row :gutter="20">
            <el-col :span="3"><div style="white-space: nowrap;">预约人姓名/手机号</div></el-col>
            <el-col :span="3"><div>预约来源</div></el-col>
            <el-col :span="3"><div>购买方案</div></el-col>
            <el-col :span="3"><div>订单金额 (元)</div></el-col>
            <el-col :span="2"><div>支付状态</div></el-col>
            <el-col :span="3"><div>跟进状态</div></el-col>
            <el-col :span="2"><div style="white-space: nowrap;">成交保单数</div></el-col>
            <el-col :span="3"><div style="white-space: nowrap;">成交保费<span>/服务费 (元)</span></div></el-col>
            <el-col :span="2"><div>操作</div></el-col>
          </el-row>
        </div>

        <div v-for="(item, index) in tableData" :key="index">
          <div class="table-info">
            <div class="new-time">购买方案时间：{{item.createTime|timeStatus}}</div>
            <div class="right">
              <div class="account-info">所属账户：{{item.mechanShortname}}</div>
              <div class="order-type">订单类型：{{item.status == "81" ? "渠道跟进" : "客服跟进"}}</div>
            </div>
          </div>
          <div class="card">
            <div class="table-row table-info1">
              <el-row :gutter="20">
                <el-col :span="3"><div><tooltip :txt-info="(item.userName||'-')+'/'+(item.mobile||'-')"></tooltip></div></el-col>
                <el-col :span="3"><div><tooltip :txt-info="item.title||all.SUBSCRIBE_SOURCE[item.source]||'-'"></tooltip></div></el-col>
                <el-col :span="3"><div><tooltip :txt-info="item.planName|filterEmpty"></tooltip></div></el-col>
                <el-col :span="3"><div>{{item.realAmount|filterEmpty}}</div></el-col>
                <el-col :span="2"><div>{{item.payStatus?'已支付':'待支付'}}</div></el-col>
                <el-col :span="3">
                  <div style="white-space:nowrap">
                    <div v-if="item.serviceStatus != 5">
                      {{item.serviceStatus | serviceStatu}}
                    </div>
                    <div v-else-if="item.result == true">
                      跟进完成 (已促成)
                    </div>
                    <div v-else-if="item.result == false">
                      跟进完成 (未促成)
                    </div>
                  </div>
                </el-col>
                <el-col :span="2"><div>{{item.totalNum|filterEmpty}}</div></el-col>
                <el-col :span="3"><div>{{item.totalFee|filterEmpty}}<span v-if="item.totalFee&&item.totalIncomes">/</span><span>{{item.totalIncomes|filterEmpty}}</span></div></el-col>
                <el-col :span="2"><div class="cz-list"><span class="xqbtn" @click="seeDetail(item.id)">详情</span></div></el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
      <div class="empty" v-if="tableData.length==0">
        <p>
          <img src="@static/images/no_msg.png" style="width:290px"/>
        </p>
        <p><span>暂无数据</span></p>
      </div>
    </div>
    <el-pagination
        v-if="tableData.length!=0"
        class="page"
        background
        :layout="$tools.pageLayout"
        :current-page.sync="current"
        @size-change="handleSizeChange"
        @current-change="orderChange"
        :page-size="10"
        :total="orderPage"
      >
      </el-pagination>
  </div>
</template>
<script>
var vm;
import athHeader from "@/components/authorizationTitle";
import topSearchForm from "@/components/topSearchForm";
import headBox from "@/components/head.vue";
import tooltip from "@/components/tooltip";
export default {
  data: () => ({
    loading:false,
    nums: 2,
    statistics:{},
    search: {},
    searchData: [],
    source:"",
    sourceList:[],
    khlxArr: [
      { desc: "客服跟进", statu: "1" },
      { desc: "渠道跟进", statu: "0" },
    ],
    khlxValue: "",
    zfArr: [
      { desc: "待支付", statu: 0 },
      { desc: "已支付", statu: 1 },
    ],
    zfValue: "",
    gjArr: [
      { desc: "待跟进", statu: 1 },
      { desc: "需求沟通", statu: 2 },
      { desc: "方案定制", statu: 3 },
      { desc: "方案解读", statu: 4 },
      { desc: "跟进完成", statu: 5 },
    ],
    gjValue: "",
    planArr: [],
    planValue: "",
    tableData: [],
    nameOrPhone: "",
    orderPage: 0,
    current:1,
    pageSize:10,
    isDeal:'',//是否有成交单
    wechat:'',//微信号
    all:{}
  }),
  components: {
    "ahb-header": athHeader,
    topSearchForm,
    headBox,
    tooltip
  },
  created() {
    vm = this;
    this.all = this.$tools.getLocal("all");
    this.sourceList = this.all.SUBSCRIBE_SOURCE;
    // const object = this.all.SUBSCRIBE_SOURCE;
    // for (const key in object) {
    //   if (Object.hasOwnProperty.call(object, key)) {
    //     const text = object[key];
    //     this.sourceList.push({
    //       desc: text, statu: key
    //     })
    //   }
    // }
    
    this.getQuerySelection();
    this.getPlanOrders({
      pageSize: this.pageSize,
      pageNum: 1,
    });
  },
  methods: {
    // 页容量改变
    handleSizeChange(num){
      this.pageSize = num;
      this.query(1);
    },
    getQuerySelection: function () {
      this.$http({
        url: "/master/paymentPlan/getQuerySelection",
        type: "get",
        params: {},
      }).then(function (data) {
        vm.planArr = data.data;
      });
    },
    getPlanOrders: function (params) {
      vm.loading = true
      this.$http({
        url: "/master/paymentPlan/getOrders",
        type: "put",
        params: params,
      }).then(function (data) {
        vm.loading = false
        vm.tableData = data.data.page.data;
        vm.orderPage = data.data.page.total;
        vm.statistics = data.statistics
      }).catch(e=>{
        vm.loading = false
      });
    },
    query: function (pageNum) {
      this.current = pageNum;
      var obj = { pageSize:this.pageSize, pageNum: pageNum };
      if (isNaN(vm.nameOrPhone * 1)) {
        obj.userName = vm.nameOrPhone;
      } else {
        obj.mobile = vm.nameOrPhone;
      }
      obj.orderStartTime = vm.searchData ? vm.searchData[0] : "";
      obj.orderEndTime = vm.searchData ? vm.searchData[1] : "";
      obj.authorizedState = vm.khlxValue;
      obj.planId = vm.planValue;
      obj.payStatus = vm.zfValue;
      obj.serviceStatus = vm.gjValue;
      obj.source = vm.source;
      obj.isDeal = vm.isDeal
      obj.wechat = vm.wechat
      vm.getPlanOrders(obj);
    },
    exportPolicyExcel: function () {
      var url = "/master/paymentPlan/exportOrders?authorizedState=" + vm.khlxValue + "&planId=" +
        vm.planValue + "&payStatus=" + vm.zfValue + "&serviceStatus=" + vm.gjValue;
      if (vm.searchData.length > 0) {
        url +=
          "&orderStartTime=" +
          vm.searchData[0] +
          "&orderEndTime=" +
          vm.searchData[1];
      } else {
        url += "&orderStartTime=&orderEndTime=";
      }
      if (isNaN(vm.nameOrPhone * 1)) {
        url += "&userName=" + vm.nameOrPhone 
      } else {
        url += "&mobile=" + vm.nameOrPhone
      }
      this.$tools.daochu(url);
    },
    orderChange: function (val) {
      vm.query(val);
    },
    seeDetail: function (id) {
      this.$router.push({
        path: "/cmzDetail",
        query: { id: id },
      });
    },
    goempower: function (id) {
      this.$router.push({
        path: "/empower",
      });
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
@import './cmzOrder';
.cmzOrder {
  .from {
    background: #fff;
    padding: 20px 30px;
    padding-bottom: 0px;
  }
}

</style>
